// 미디어 타입 정의
export const MEDIA_TYPES = {
  // 비디오 타입
  mp4: 'video/mp4',
  webm: 'video/webm',
  ogg: 'video/ogg',
  mov: 'video/quicktime',
  // 이미지 타입
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
} as const;

// 비디오 타입만 분리
export const VIDEO_TYPES = {
  mp4: MEDIA_TYPES.mp4,
  webm: MEDIA_TYPES.webm,
  ogg: MEDIA_TYPES.ogg,
  mov: MEDIA_TYPES.mov,
} as const;

export const DEFAULT_IMAGE_ACCEPT_TYPE = {
  'image/jpeg': [],
  'image/jpg': [],
  'image/png': [],
  'video/mp4': [],
  'video/webm': [],
  'video/quicktime': [],
} as const;

export const VIDEO_EXTENSIONS = ['mp4', 'mov', 'webm'];
